import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import {Row, Col} from 'react-flexbox-grid/lib';
import { connect } from 'react-redux';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import { Player } from 'video-react';
import styles from './styles/BOMDataStyles';

class VideoData extends React.Component {
    render() {
        console.info("Video Player data rendered");

        return (
            <div style={styles.mainDataRow}>
                <Row>
                    <Col xs={12} >
                        <Card initiallyExpanded={true} >
                            <CardHeader
                                title={"Note: the video file below is for illustration purposes only. It is not the same event as the case file crash"}
                            />
                            <CardText expandable={true} >
                            <Player
                                autoPlay={true}
                                position="center"
                                src="https://www.dropbox.com/s/v2cb4dryd13rjul/intersection-crash_ch1.mp4?raw=1"
                                />
                            </CardText>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

VideoData.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    }
}
export default connect(mapStateToProps, null)(VideoData);



// WEBPACK FOOTER //
// ./src/components/detailsPage/VideoData.js